import EA from 'helpers/init';

export default EA.Methods.saveLangCookie = ($this, payload) => {
    $this.addEventListener('click', function() {
        const dataLangValue = this.getAttribute('data-lang');
        if(getCookie('cb_accepted')){
            setCookie('lang_cookie',dataLangValue,364);
        }
    });


    
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + value + "; expires=" + expires + "; path=/; SameSite=Lax; Secure";
};
function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
};
};
